import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { authService } from "../../services/auth"; 
import { useAuthStore } from "../../store/authStore"; 
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel"; 
import { ProgressSpinner } from "primereact/progressspinner";
import { initializeOneSignal } from "../../services/oneSignal";
import jwtDecode from "jwt-decode";


export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const setUser = useAuthStore((state) => state.setUser);
  const [loading, setLoading] = useState(false);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // isAuthenticated kontrolü
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/admin/dashboard");
    } 
  }, [isAuthenticated, navigate]);



const onLogin = async () => {
  setLoading(true);
  try {
    const response = await authService.login(email, password);
    const token = response.data.token;
    localStorage.setItem("token", token);

    const decodedToken = jwtDecode(token);

    const userId = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
    const userName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];

    console.log("User ID:", userId);
    console.log("User Name:", userName);
 
    setUser(response.data.claims, token, response.data.refreshToken,userId,userName);
 
    toast.success("Giriş başarılı.");
    navigate("/admin/dashboard");
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      toast.error("İnternet bağlantınızı kontrol ediniz!");
    } else {
      toast.error("Giriş başarısız oldu. Lütfen bilgilerinizi kontrol edin.");
    }
  } finally {
    setLoading(false);
  }
};


  const onForgetPassword = async () => {
    try {
      navigate("/forgot-password");
    } catch (error) {
      toast.error("Giriş başarısız oldu. Lütfen bilgilerinizi kontrol edin.");
    }
  };
  
  return (
    <div
      className="flex justify-content-center align-items-center h-screen w-screen surface-200 "
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
       {loading && (
        <div className="flex fixed  border-primary-100 border-3 border-round-md z-1 h-6rem w-6rem bg-white justify-content-center align-items-center">
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          />
        </div>
      )}
      <div className="grid surface-ground	  text-color m-4 border-round-xl shadow-5">
        <div className=" col-12 md:col-6   border-round-xl align-items-center justify-content-center     font-bold  px-5 py-3   ">
          <h2>Boyer Müşteri Portalı</h2>
          <div className="    pt-5 pb-3">
            <FloatLabel>
              <InputText
                id="berpmmail"
                className="w-full"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="username">Kullanıcı Adı</label>
            </FloatLabel>
          </div>
          <div className="  pt-3 pb-5 ">
            <FloatLabel>
              <Password
                id="berpmpassword"
                inputStyle={{ width: "100%" }}
                style={{ width: "100%" }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                feedback={false}
                toggleMask
                inputClassName="w-full"
                className="  w-full"
                pt={{ iconField: { root: { className: "w-full" } } }}
              />
              <label htmlFor="password">Şifre</label>
            </FloatLabel>
          </div>
          <div className="flex justify-content-end align-items-center w-full ">
            <span className="text-sm">Şifreni mi unuttun?</span>
            <Button
              outlined
              severity="secondary"
              className="text-sm ml-3"
              label="Şifreni yenile"
              onClick={onForgetPassword}
            />
          </div>
          <div className=" pt-5 pb-5 ">
            <Button
              className="w-full"
              label="Giriş Yap"
              icon="pi pi-angle-right"
              iconPos="right"
              onClick={onLogin}
            ></Button>
          </div>
        </div>
        <div className="col-12 md:col-6 bg-primary border-round-xl px-5 py-3 flex align-items-center justify-content-center">
          <div className="text-center">
            <h1>Hoş Geldiniz</h1>
            <span>Boyer hizmetlerine erişim için giriş yapınız.</span>
            <p>
              Eğer giriş bilgileriniz yoksa servis sağlayıcısından talep ediniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}